import React, { useState } from 'react';
import { FiPlus, FiSearch } from 'react-icons/fi';
import Layout from '../components/Layout';
import CustomersTable from '../components/Tables/CustomersTable';
import { renderIcon } from '../utils/iconRenderer';
import { dummyCustomers } from '../utils/dummyData';
import { Customer } from '../types/models';

const Customers: React.FC = () => {
  const [customers, setCustomers] = useState<Customer[]>(dummyCustomers);
  const [searchTerm, setSearchTerm] = useState('');

  // Filter customers based on search term
  const filteredCustomers = customers.filter(
    customer =>
      customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      customer.phone.includes(searchTerm)
  );

  const handleEdit = (customer: Customer) => {
    console.log('Edit customer:', customer);
    // TODO: Implement edit modal
  };

  const handleDelete = (customerId: string) => {
    if (window.confirm('Are you sure you want to delete this customer?')) {
      setCustomers(prev => prev.filter(c => c.id !== customerId));
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Customers</h1>
          <p className="text-gray-600 mt-1">Manage and view customer information</p>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          {renderIcon(FiPlus, { size: 20 })}
          <span>Add Customer</span>
        </button>
      </div>

      {/* Search Bar */}
      <div className="bg-white rounded-lg shadow p-4">
        <div className="relative">
          <span className="absolute left-3 top-3 text-gray-400">{renderIcon(FiSearch, { size: 20 })}</span>
          <input
            type="text"
            placeholder="Search by name, email, or phone..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-lg shadow p-4">
          <p className="text-gray-600 text-sm font-medium">Total Customers</p>
          <p className="text-2xl font-bold text-gray-900 mt-1">{customers.length}</p>
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <p className="text-gray-600 text-sm font-medium">Active Orders</p>
          <p className="text-2xl font-bold text-blue-600 mt-1">
            {customers.filter(c => c.orderStatus === 'Active').length}
          </p>
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <p className="text-gray-600 text-sm font-medium">Paid Payments</p>
          <p className="text-2xl font-bold text-green-600 mt-1">
            {customers.filter(c => c.paymentStatus === 'Paid').length}
          </p>
        </div>
        <div className="bg-white rounded-lg shadow p-4">
          <p className="text-gray-600 text-sm font-medium">Pending Payments</p>
          <p className="text-2xl font-bold text-yellow-600 mt-1">
            {customers.filter(c => c.paymentStatus === 'Pending').length}
          </p>
        </div>
      </div>

      {/* Customers Table */}
      <CustomersTable
        customers={filteredCustomers}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
      </div>
    </Layout>
  );
};

export default Customers;
